const state = {
  dataCVConf: {},
  layoutCVConf: {},
  x1CVConf: -1,
  x2CVConf: -1
}

const getters = {
  getDataCVConf: state => state.dataCVConf,
  getLayoutCVConf: state => state.layoutCVConf,
  getX1CVConf: state => state.x1CVConf,
  getX2CVConf: state => state.x2CVConf
}

const actions = {
  setPlotCVConf ({ commit }, { data, layout }) {
    commit('SET_DATA_CVConf', data)
    commit('SET_LAYOUT_CVConf', layout)
  },
  setX1CVConf ({ commit }, x1) {
    x1 = Math.abs(x1)// Always positive
    x1 = Math.round(x1 * 100) / 100 // Round two decimals
    commit('SET_X1_CVConf', x1)
  },
  setX2CVConf ({ commit }, x2) {
    x2 = Math.abs(x2)// Always positive
    x2 = Math.round(x2 * 100) / 100 // Round two decimals
    commit('SET_X2_CVConf', x2)
  }
}

const mutations = {
  SET_DATA_CVConf: (state, dataCVConf) => (state.dataCVConf = dataCVConf),
  SET_LAYOUT_CVConf: (state, layoutCVConf) => (state.layoutCVConf = layoutCVConf),
  SET_X1_CVConf: (state, x1) => (state.x1CVConf = x1),
  SET_X2_CVConf: (state, x2) => (state.x2CVConf = x2)
}

export default {
  state,
  getters,
  actions,
  mutations
}
